import { render, staticRenderFns } from "./sectorDialog.vue?vue&type=template&id=2ca4b06a"
import script from "./sectorDialog.vue?vue&type=script&lang=js"
export * from "./sectorDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src881454487/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ca4b06a')) {
      api.createRecord('2ca4b06a', component.options)
    } else {
      api.reload('2ca4b06a', component.options)
    }
    module.hot.accept("./sectorDialog.vue?vue&type=template&id=2ca4b06a", function () {
      api.rerender('2ca4b06a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sectors/sectorDialog.vue"
export default component.exports